var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",attrs:{"draggable":"true"},on:{"drop":function($event){$event.stopPropagation();return _vm.drop.apply(null, arguments)},"dragover":function($event){$event.stopPropagation();return _vm.dragover.apply(null, arguments)},"dragenter":_vm.dragenter,"dragleave":_vm.dragleave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }